module.exports = __webpack_public_path__ + "static/media/bg_0.6fbab050.jpg";